<template>
  <div class="progressHandOver flexcenter">
    <transition>
      <div class="handOver flexcenter">
        <!-- 閉じる -->
        <div class="modal-close" v-on:click="$emit('close')"></div>

        <div class="lbold font20 modal-title">このアクティビティに現在の進捗度を引き継ぎますか？</div>
        <button class="reset" type=button v-on:click="clickButton(false)"><span class="font17 lbold">いいえ</span><span class="font13 block">(リセットしてやり直す)</span></button>
        <button class="yes" type=button v-on:click="clickButton(true)"><span class="font17 lbold">はい</span><span class="font13 block">(現在の進捗を引き継ぐ)</span></button>
      </div>
    </transition>
  </div>
</template>

<script>
import common from '@/mixin/common'

export default {
  name: 'progressHandOver',
  mixins: [
    common,
  ],
  methods: {
    clickButton: function(flag) {
      this.$emit('clickButton', flag)
    }
  },
  mounted: function() {
    this.log("ProgressHandOver start mounted")
    this.setBodyStylePosition(true)
  },
  beforeDestroy: function() {
    this.setBodyStylePosition(false)
  }
}
</script>

<style lang="scss">
@import 'src/assets/style/modal';
</style>



// WEBPACK FOOTER //
// ProgressHandOver.vue?89f99b60